import { useDocument } from 'hooks';

export type useArtistParams = {
  artistId: string;
};

const useArtist = ({ artistId }: useArtistParams) => {
  const { state, data } = useDocument(artistId ? `/usersWeb/${artistId.trim()}` : '', false);

  return {
    state,
    data,
  };
};

export default useArtist;
